import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const PrivateRoute = () => {
  const isAuthenticated = localStorage.getItem('access_token');  

  if (!isAuthenticated) {
    
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;  
};

export default PrivateRoute;
